import StatusHandler from 'app/shared-components/StatusHandler'
import {
    WithId,
} from 'app/types/common.types'

import useGetEngagement from '../hooks/useGetEngagement'
import EngagementForm from '../EngagementForm'

const EngagementOverview = ({
    id,
}: Readonly<WithId<number>>) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
    } = useGetEngagement(id)

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <EngagementForm
                data={data}
                disabled
            />
        </StatusHandler>
    )
}

export default EngagementOverview
